import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { TextLeaf as RichSlateTextLeaf } from 'src/components/RichSlate';

export const InsightsLeafDefault = forwardRef(
  ({ attributes, leaf, children, ...restProps }, ref) => (
    <RichSlateTextLeaf
      leaf={leaf}
      attributes={attributes}
      ref={ref}
      {...restProps}
    >
      {children}
    </RichSlateTextLeaf>
  )
);

InsightsLeafDefault.propTypes = {
  attributes: PropTypes.shape({}),
  leaf: PropTypes.shape({
    decoration: PropTypes.string,
  }),
  children: PropTypes.shape({}),
};

InsightsLeafDefault.defaultProps = {
  attributes: null,
  leaf: null,
  children: null,
};
